// Update src/stores/veradigmStore.js

import { create } from 'zustand';

const initialState = {
  // Organization level - is the feature enabled?
  isEnabled: false,
  // User level - is this specific user connected?
  isConnected: false, // Don't initialize from localStorage
  isLoading: false,
  error: null,
};

export const useVeradigmStore = create((set) => ({
  ...initialState,
  
  // Set organization-level enablement
  setFeatureEnabled: (enabled) => set({ isEnabled: enabled }),
  
  // Set user-level connection status
  setConnectionStatus: (status) => {
    if (status) {
      localStorage.setItem('veradigm_connected', 'true');
    } else {
      localStorage.removeItem('veradigm_connected');
    }
    set({ isConnected: status });
  },
  
  setLoading: (loading) => set({ isLoading: loading }),
  setError: (error) => set({ error }),
  
  // Clear all user-specific state
  clearUserConnection: () => {
    localStorage.removeItem('veradigm_connected');
    set({ 
      isConnected: false, 
      isLoading: false, 
      error: null 
    });
  },
  
  reset: () => {
    localStorage.removeItem('veradigm_connected');
    set({ 
      isConnected: false, 
      isLoading: false, 
      error: null 
      // Note: We don't reset isEnabled here as that's based on organization settings
    });
  },
}));